export default "/static/webpack/media/no.38042cbf.svg";